import React from 'react';
import {
  BackFullIcon,
  Container,
  Content,
  Header,
  HeaderActions,
  HeaderBack,
  HeaderInfo,
  HeaderTitle,
  LoadRow,
  NextPageButton,
  PaginationArea,
  PreviousPageButton,
  ClientsContainer,
  Menu,
  Responsive,
  SearchComp,
  LoadComp,
  Card,
  ModalClient,
  ModalPdf,
  ModalManagePdf,
} from './styles';

import { toast } from 'react-toastify';
import { useTheme } from 'styled-components';
import { useLocation } from 'react-router-dom';
import { PersonalClientCRUD } from 'services/requests/personal-client';
import PersonalClientCRUDProps, { PersonalClientData } from 'services/requests/personal-client/index.d';
import { CONST_PERSONAL_CLIENT_KAMBAM_STEP } from 'utils/CONSTANTS';

const personalClientCrud = new PersonalClientCRUD();

const ArchiveRecolocationPage: React.FC = () => {
  const { colors } = useTheme();
  const location = useLocation();
  const { kanban_step } = location.state || {}; 

  // Ref
  const currentPage = React.useRef(1);
  const lastSearch = React.useRef('');

  // States
  const [search, setSearch] = React.useState('');
  const [clients, setClients] = React.useState<PersonalClientCRUDProps.readReturn>();
  const [loading, setLoading] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [showPDF, setPDFModal] = React.useState(false);
  const [showManagePDF, setManagePDF] = React.useState(false);
  const [currentClient, setCurrentClient] = React.useState<PersonalClientData>();
  const [currentPdf, setCurrentPdf] = React.useState<number | undefined>();

  // Callbacks
  const refreshData = React.useCallback(async (page?: number, name?: string) => {
    try {
      if(loading) return;
      setLoading(true);

      currentPage.current = page || 1;
      lastSearch.current = name || '';
      
       const stepFinded = CONST_PERSONAL_CLIENT_KAMBAM_STEP[
          CONST_PERSONAL_CLIENT_KAMBAM_STEP.findIndex(
            item =>
              item.label.toLowerCase() === kanban_step.toLocaleLowerCase(),
          )
        ].keys;

      const { data, status, error } = await personalClientCrud.read({
        page,
        kanban_step: stepFinded,
        per_page: 12,
        name
      });

      if (error) {
        throw new Error(error.message.description);
      }

      if (status === 200 && data) {
        setClients(data);
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoading(false);
    }
  }, [kanban_step]);

  const handleVisualizatePdf = React.useCallback(async ({id}: {id: number}) => {
    try {
      if(!id) throw new Error('Não foi possivel selecionar o currículo');
      setCurrentPdf(id)
      setPDFModal(true)
    } catch (e) {
      const { message } = e as Error;
      toast.error(message)
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    refreshData();
  }, []);

  React.useEffect(() => {
    if(!search && !lastSearch.current) return;
    console.log(search);
    refreshData(1, search);
  }, [search])

  return (
    <Container>
      <Menu currentPage="Recolocação" />
      <Content>
        <Responsive>
          <Header>
            <HeaderBack href="/recolocacao-profissional">
              <BackFullIcon />
            </HeaderBack>
            <HeaderInfo>
              <HeaderTitle>Clientes no passo KanBan - {kanban_step}</HeaderTitle>
              <HeaderActions>
                <SearchComp
                  value={search}
                  setValue={setSearch}
                  placeholder={`Pesquisar Clientes`}
                  isLoading={loading}
                />
              </HeaderActions>
            </HeaderInfo>
          </Header>
          <ClientsContainer>
            {loading ? (
              <LoadRow>
                <LoadComp
                  customStyle={{
                    color: colors.secondaryDark,
                  }}
                  size="extraLarge"
                />
              </LoadRow>
            ) : (
              <>
                {clients && clients.PersonalClient?.length > 0 ? (
                  clients.PersonalClient?.map((e, i) => {
                    return (
                      <Card
                        onClick={() => {
                          setCurrentClient(e);
                          setShowModal(true);
                        }}
                        client={{
                          advisor_relation: e.advisor_relation,
                          budget: e.budget,
                          client_type: e.client_type,
                          cpf: e.cpf,
                          id: e.id,
                          image: e.image,
                          kanban_step: e.kanban_step,
                          local: e.local,
                          name: e.name,
                          occupation: e.occupation,
                          status: e.status,
                          vacancy_matching_quantity: e.vacancy_matching_quantity,
                        }}
                        haveMargin
                      />
                    );
                  })
                ) : (
                  <HeaderTitle>Nenhum cliente encontrado...</HeaderTitle>
                )}
                <PaginationArea>
                  {clients?.has_prev && (
                    <PreviousPageButton
                      title="Voltar Página"
                      callback={() => refreshData(currentPage.current - 1, search)}
                    />
                  )}
                  {clients?.has_next && (
                    <NextPageButton
                      title="Proxima Página"
                      callback={() => refreshData(currentPage.current + 1, search)}
                    />
                  )}
                </PaginationArea>
              </>
            )}
          </ClientsContainer>
        </Responsive>
      </Content>

      {showModal && (
        <ModalClient
          personalClient={currentClient?.id}
          refreshData={refreshData}
          onClose={() => {
            setShowModal(false);
            setCurrentClient(undefined);
          }}
          showPdfCallback={() => setManagePDF(true)}
        />
      )}

      {showPDF && (
        <ModalPdf
          onClose={() => {
            setPDFModal(false);
          }}
          pdfId={currentPdf}
        />
      )}

      {showManagePDF && (
        <ModalManagePdf
          userId={currentClient?.id}
          userName={currentClient?.name} 
          type='personal_client' 
          onClose={() => {
            setManagePDF(false)
          }}
          onVisualizate={handleVisualizatePdf}
        />
      )}
    </Container>
  );
};

export default ArchiveRecolocationPage;
